<template>
  <div id="Wrapper">
    <Header
      :siteInfo="siteInfo"
    />
    <div class="main_container">
      <Sidebar
        :siteInfo="siteInfo"
      />
      <LiveMain
        v-if="siteInfo !== null && cameraInfo !== null"
        :siteInfo="siteInfo"
        :cameraInfo="cameraInfo"
        @loadFinish="loadFinish"
      />
    </div>
  </div>
</template>
<script>
import Header from '../../components/header/Header'
import Sidebar from '../../components/sidebar/Sidebar'
import LiveMain from '../../components/main/LiveMain'

export default {
  name: 'Live',
  data: function(){
    return {
    }
  },
  props:{
    siteInfo:{
      type: Array
    },
    cameraInfo:{
      type: Array
    },
  },
  methods: {
    loadFinish() {
      this.$emit('loadFinish');
    },
  },
  components:{
    Header,
    Sidebar,
    LiveMain
  }
}
</script>
<style lang="scss">
</style>